import React from 'react';
import PropTypes from 'prop-types';
import Translate from '../common/Translate';
import { currencySign } from '../../Utils/currencySign';

const Totals = ({ totals }) => {
  Object.keys(totals).map((total) => {
    if (total.split('_').length > 3) return null;
    return (
      <div>
        <Translate code={total} /> {currencySign(totals[total])}
      </div>
    );
  });

  return null;
};
export default Totals;

Totals.propTypes = {
  totals: PropTypes.shape().isRequired,
};
